
import { IBusinessRequest } from "@/models/interfaces/interfaces";
import { BusinessRequest, BusinessRequestImage } from "../BusinessRequest";

/**
 * Builder class for BusinessRequest objects.
 */
export class BusinessRequestBuilder {
    private businessRequest!: IBusinessRequest;
    private business_request_images: BusinessRequestImage[] = []



    /**
     * Sets the data for the BusinessRequest being built.
     * @param {IBusinessRequest} businessRequestData - The data for the Work.
     * @returns {BusinessRequestBuilder} - Returns the current instance of the BusinessRequestBuilder for method chaining.
     */
    public setBusinessRequest(businessRequestData: IBusinessRequest): BusinessRequestBuilder {
        this.businessRequest = businessRequestData
        return this
    }



    /**
     * Sets the images for the BusinessRequest.
     * @param {IBusinessRequestImage[]} businessRequestImages - The list of images for the BusinessRequest.
     * @returns {BusinessRequestBuilder} - Returns the current instance of the BusinessRequestBuilder for method chaining.
     */
    public setImages(businessRequestImages: BusinessRequestImage[]): BusinessRequestBuilder {
        businessRequestImages.forEach(image => {
            this.business_request_images.push(new BusinessRequestImage(image))
        });
        return this
    }



    /**
    * Builds and returns the fully BusinessRequest object.
    * @returns {BusinessRequest} - The fully BusinessRequest object.
    */
    public build(): BusinessRequest {
        let businessRequest = new BusinessRequest(this.businessRequest)
        if (this.business_request_images) businessRequest.business_request_images = this.business_request_images

        return businessRequest
    }
}